<span class="status" matTooltip="{{tooltips[status]}}" matTooltipPosition="above">

  <!-- Dot indicator status -->
  <span *ngIf="status === 'recording' || status === 'completed'; else textStatus"
        [ngStyle]="{'background-color':colors[status] ? colors[status] : status }"
        [ngClass]="{'dot': true, 'flikering-dot': status === 'recording'}">
  </span>

  <!-- Text status -->
  <ng-template #textStatus>{{getTextTooltip(status)}}</ng-template>
</span>
